import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import styles from './login-disclaimer.module.scss';
import cx from 'classnames';
export const LoginDisclaimer = ({ text, className }) => {
    return (_jsxs("div", { className: cx('d-flex align-items-center my-3', className), children: [_jsx(CatIconWarningCircle, { className: "me-2" }), _jsx("p", { className: cx(styles['login-disclaimer-text'], 'cat-u-theme-typography-body-sm mb-0'), children: text })] }));
};
